import { Box } from "@mui/material";
import User from "./User";

export default function ListUser({dataParticipants, setChangeDataParticipant, OperatorRole, displayCloseIcon}){

    return (
        <Box sx={{height: '100%', overflowY: 'auto'}}>
            <Box sx={{display: 'flex', flexWrap: 'wrap', paddingBottom: '10px'}}>
                {dataParticipants?.map((dataParticipant, index) => {
                    return (
                        <User 
                            OperatorRole={OperatorRole} 
                            dataParticipant={dataParticipant} 
                            index={index} 
                            setChangeDataParticipant={setChangeDataParticipant}
                            displayCloseIcon={displayCloseIcon}
                        />
                    )
                })}
            </Box>
        </Box>
    )
}